import React from 'react'
import { roleWisePermissions } from './RoleAndPermissions'

const CheckPermission = ({ permission, children }) => {
  let user_role = localStorage.getItem('user_role')
  let allPermissions = roleWisePermissions(user_role) || []

  return allPermissions.includes(permission) ? <>{children}</> : null
}

export default CheckPermission
